import { useState, useEffect } from 'react';

import { Grow } from '@mui/material';
import { useRouter } from 'next/router';

import { getAudByUuid } from '@/api/getAudByUuid';
import { PrimaryButton } from '@/components/Button/PrimaryButton';
import { Spinner } from '@/components/Spinner/Spinner';
import TokenMember from 'interfaces/tokenMembers';
import CheckLogo from 'public/assets/check2.svg';
import ExpandIcon from 'public/assets/expand.svg';

export function AirDropStatus({
  AudUUID,
  setSuccessfulAirdrop,
  setShowAudience,
  file,
}: {
  AudUUID: string;
  setSuccessfulAirdrop?: Function;
  setShowAudience?: Function;
  file?: any;
}) {
  const [allAridropped, setAllAridropped] = useState<boolean>(false);
  const [tokenMembers, setTokenMembers] = useState<TokenMember[]>([]);
  const [Link, setLink] = useState(null);
  const router = useRouter();

  const fetchAudience = async () => {
    if (!AudUUID) return;
    const res = await getAudByUuid(AudUUID);
    if (res?.data?.token?.explorerLink) {
      setLink(res?.data?.token?.explorerLink);
    }
    setTokenMembers(res.data?.members);
    const dataMembers = res.data?.members;
    const count = dataMembers.filter((m: any) => m.airdropped === true).length;
    if (count === dataMembers.length) {
      setAllAridropped(true);
    }
  };

  useEffect(() => {
    const poll = setInterval(() => {
      fetchAudience();
    }, 5000);
    fetchAudience();
    if (allAridropped) {
      clearInterval(poll);
    }
    return () => {
      clearInterval(poll);
    };
  }, [allAridropped]);

  const handleDone = () => {
    if (setSuccessfulAirdrop) {
      setSuccessfulAirdrop(true);
    }
    if (setShowAudience) {
      setShowAudience(false);
    }
  };

  return (
    <div className="bg-white items-center h-full grid grid-rows-6 flex-col">
      <div className="row-span-1 flex items-center justify-center ">
        <div className="font-bold text-2xl mr-4  flex justify-center">
          <p className="w-full">Smart Contract Deployed</p>
        </div>
        {Link && (
          <Grow in={Link}>
            <a
              className={`flex h-full items-center`}
              href={Link}
              target="_blank"
              rel="noreferrer"
            >
              <p className="mr-4 text-gray-400 hover:text-black">
                Check in Explorer
              </p>
              <img className="w-4" src={ExpandIcon.src} alt="Check Explorer" />
            </a>
          </Grow>
        )}
      </div>
      <div className="flex  row-span-5 flex-col overflow-scroll h-full rounded-lg w-full my-4">
        <div className="flex flex-row justify-between ">
          <div className="font-semibold w-[60%] border rounded-lg rounded-r-none border-r-0  border-black text-center py-2">
            Addresses
          </div>
          <div className="font-semibold w-[40%] min-w-fit border border-black rounded-lg rounded-l-none text-center py-2">
            Airdropped
          </div>
        </div>
        <div className="flex flex-row justify-between border-2 rounded-lg my-2 text-sm h-full overflow-auto">
          <div className=" w-full h-full">
            {tokenMembers.map((member, id) => (
              <div className="flex w-full border" key={id}>
                <div className="w-[60%]   border-r-2 px-2 py-2">
                  <p className="overflow-x-scroll no-scrollbar w-full">
                    {member.ensName ? member.ensName : member.address}
                  </p>
                </div>
                <div className="w-[40%]  px-2 py-2 flex justify-center">
                  {member.airdropped ? (
                    <div className="flex items-center justify-center">
                      <img
                        src={CheckLogo.src}
                        alt="Airdropped"
                        className="h-6"
                      />
                    </div>
                  ) : (
                    <div className="flex items-center justify-center">
                      <Spinner height={4} width={4} />
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {router.query.editAudience === 'true' ||
      router.query.setAccess === 'true' ? (
        <div className={`w-full row-span-1 flex justify-center`}>
          <PrimaryButton onClick={handleDone}>
            <span>Done</span>
          </PrimaryButton>
        </div>
      ) : (
        <div className=" mt-8 flex items-center  w-full">
          <button
            onClick={handleDone}
            className={`bg-gray-200 font-semibold  py-2 px-8 border rounded-lg`}
          >
            Cancel
          </button>
          <div className="flex w-full justify-end">
            <button
              onClick={() =>
                router.push(`/files/${file.data.uuid}?setAccess=true`)
              }
              className={` bg-yellow font-semibold   py-2 px-8 border rounded-lg`}
            >
              Edit Access
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
